import { render, staticRenderFns } from "./THead.vue?vue&type=template&id=644dd23f&scoped=true&"
import script from "./THead.vue?vue&type=script&lang=ts&"
export * from "./THead.vue?vue&type=script&lang=ts&"
import style0 from "./THead.vue?vue&type=style&index=0&id=644dd23f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644dd23f",
  null
  
)

export default component.exports